import { render, staticRenderFns } from "./ModalCreateClient.vue?vue&type=template&id=45a3033c"
import script from "./ModalCreateClient.vue?vue&type=script&lang=js"
export * from "./ModalCreateClient.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateClient.vue?vue&type=style&index=0&id=45a3033c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports